import React from "react";
import styled from "styled-components";

function Navigation({ showBackButton, showNextButton, setPage, page, nextButtonCallback = () => { } }) {
  const handleBackButton = () => {
    setPage(page - 1);
  };

  const handleNextButton = () => {
    setPage(page + 1);
    nextButtonCallback();
  };

  return (
    <NavigationContainer>
      {showBackButton ? (
        <BackButton onClick={handleBackButton} >
          <NavigationButtonCircleLeft />
        </BackButton>
      ) : (
        <FakeButton />
      )}
      {showNextButton ? (
        <NextButton onClick={handleNextButton} >
          <NavigationButtonCircleRight />
        </NextButton>
      ) : (
        <FakeButton />
      )}
    </NavigationContainer>
  );
}

export default Navigation;

const NavigationContainer = styled.div`
  width: 100%;
  padding: 35px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const NavigationButton = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 15px;
  background-position: center;
  overflow: hidden;
  background-repeat: no-repeat;
  cursor: pointer;
  background-color: rgba(57,56,146,0.8);
`;

const NextButton = styled(NavigationButton)`
  background-image: url("/assets/front/img/edustrada/arrow-right.png");
`;

const BackButton = styled(NavigationButton)`
  background-image: url("/assets/front/img/edustrada/arrow-left.png");
`;

const FakeButton = styled(NavigationButton)`
  opacity: 0;
`;

const NavigationButtonCircle = styled.div`
  width: 50px;
  height: 50px;
  background-color: #1ec6e8;
  border-radius: 100px;
  position: relative;
  -webkit-filter: blur(7px);
  filter: blur(7px);
`;

const NavigationButtonCircleLeft = styled(NavigationButtonCircle)`
  right: 35px;
`

const NavigationButtonCircleRight = styled(NavigationButtonCircle)`
  left: 35px;
`